import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { supabase } from '../supabaseClient';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [session, setSession] = useState(null);
  const [boot, setBoot] = useState(null);      // { membership, teamspaces }
  const [loading, setLoading] = useState(true);

  const loadBootstrap = useCallback(async (activeSession) => {
    if (!activeSession) { setBoot(null); return; }
    const { data, error } = await supabase.rpc('workspace_bootstrap');
    if (error) {
      // eslint-disable-next-line no-console
      console.error('workspace_bootstrap 오류', error);
      setBoot(null);
    } else {
      setBoot(data);
    }
  }, []);

  useEffect(() => {
    let mounted = true;
    supabase.auth.getSession().then(async ({ data }) => {
      if (!mounted) return;
      setSession(data.session);
      await loadBootstrap(data.session);
      setLoading(false);
    });

    const { data: sub } = supabase.auth.onAuthStateChange(async (_event, newSession) => {
      setSession(newSession);
      await loadBootstrap(newSession);
    });
    return () => { mounted = false; sub.subscription.unsubscribe(); };
  }, [loadBootstrap]);

  const signOut = useCallback(() => supabase.auth.signOut(), []);

  const value = {
    session,
    user: session?.user ?? null,
    membership: boot?.membership ?? null,
    teamspaces: boot?.teamspaces ?? [],
    loading,
    signOut,
    refresh: () => loadBootstrap(session),
  };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
